import React, { useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { LocalizedText } from "../i18n/LocalizedCopy";

function FailurePage({ onRetry }) {
  const heading = useRef(null);
  useEffect(() => { heading.current?.focus(); }, []);
  return <section className="route-failure" role="alert" aria-labelledby="route-failure-title">
    <h1 id="route-failure-title" ref={heading} tabIndex={-1}><LocalizedText source="Cette page n’a pas pu s’afficher." /></h1>
    <p><LocalizedText source="Vous pouvez réessayer ou revenir à l’accueil. Si vous étiez en train de payer, vérifiez l’état de votre opération avant de recommencer." /></p>
    <button type="button" onClick={onRetry}><LocalizedText source="Réessayer l’affichage" /></button>
    <Link to="/"><LocalizedText source="Revenir à l’accueil" /></Link>
    <Link to="/mes-eternua/support"><LocalizedText source="Contacter Eternua" /></Link>
  </section>;
}

export class PageFailureBoundary extends React.Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidUpdate(previousProps) {
    if (this.state.failed && previousProps.routePath !== this.props.routePath) this.setState({ failed: false });
  }
  render() {
    return this.state.failed ? <FailurePage onRetry={() => this.setState({ failed: false })} /> : this.props.children;
  }
}

export default function RouteFailureBoundary({ children }) {
  const { pathname } = useLocation();
  return <PageFailureBoundary routePath={pathname}>{children}</PageFailureBoundary>;
}
